import css from "../../css/listing/agent.module.css";

import React from "react";
import PropTypes from "prop-types";
import phoneLinkFormatter from "../../helper/phoneLinkFormatter";
import Avatar from "../agents/Avatar";
import { THUMB_150_150 } from "../../service/photo";
import useMobile from "../../hooks/useMobile";

const User = (props) => {
    const { user, type } = props;
    const isMobile = useMobile();

    return (
        <div className={css.agent}>
            <div className={css.photo}>
                <Avatar photo={user.photo} size={THUMB_150_150} />
            </div>
            <div className={css.name}>
                {user.first_name} {user.last_name}
            </div>
            <div className={css.type}>
                {type === "owner" && "Property Owner"}
                {type === "manager" && "Property Manager"}
            </div>
            {user.phone && (
                <>
                    {isMobile && (
                        <div className={css.buttons}>
                            <a
                                href={phoneLinkFormatter(user.phone)}
                                className={css.buttonCall}
                            >
                                {type === "owner" && "Call Owner"}
                                {type === "manager" && "Call Manager"}
                            </a>
                        </div>
                    )}
                    {!isMobile && <div className={css.phone}>{user.phone}</div>}
                </>
            )}
            <div className={css.clear} />
        </div>
    );
};

User.propTypes = {
    user: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
};

export default User;
